import { Popover } from 'antd'
import DownLoad from './Download'
import LOGO from "@/assets/images/logo.png";
import { detectDevice } from "@/utils"


const VIDEO_IMG = 'https://ps-cdn.cemeta.cn/configs/frontend/20250917/4.jpg'
const xiaohongshu_link = 'https://www.xiaohongshu.com/user/profile/63070886000000000f005dba';
const bilibili_link = 'https://space.bilibili.com/3546687805065289'
const douyin_link = 'https://v.douyin.com/JZSjiobaTis/%201@2.com'

export const RenderFooter: React.FC = () => {
    const isPc = detectDevice()
    if (!isPc) {
        return (
            <>
                <DownLoad />
                <div className="footer_wrap">
                    <div></div>
                    <div className="footer" style={isPc ? {} : { fontSize: '0.6em' }}>
                        <div>ICP备案/许可证号:</div>
                        <a
                            href="https://beian.miit.gov.cn/#/Integrated/index"
                            target="_blank"
                            rel="nofollow noreferrer"
                        >
                            沪ICP备2021000956号-3
                        </a>
                        <img
                            src="https://qcloudimg.tencent-cloud.cn/raw/eed02831a0e201b8d794c8282c40cf2e.png"
                            style={{ marginRight: 5, height: 14 }}
                            alt="备案图标"
                        />
                        <a
                            href="https://beian.mps.gov.cn/#/query/webSearch?code=2021000956"
                            target="_blank"
                            rel="nofollow noreferrer"
                            style={{ alignItems: "center" }}
                        >
                            沪ICP备2021000956号
                        </a>
                    </div>
                </div>
            </>
        )
    }
    /* <!----> 备案编号 */
    return (
        <>
            <DownLoad />
            <div className="footer_wrap">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img style={{ width: '110px', height: 'auto', marginLeft: '48px' }} src={LOGO} alt="logo" />
                    {/* <div className="divider"></div> */}
                    {/* <div className="title-container" style={{ marginLeft: '8px' }}>
              <div className="meta-title" style={{ color: '#ffffff' }}>森宇宙</div>
            </div> */}

                    <div className="footer" style={{ marginLeft: '120px' }}>
                        <div>ICP备案/许可证号:</div>
                        <a
                            href="https://beian.miit.gov.cn/#/Integrated/index"
                            target="_blank"
                            rel="nofollow noreferrer"
                        >
                            沪ICP备2021000956号-3
                        </a>
                        <img
                            src="https://qcloudimg.tencent-cloud.cn/raw/eed02831a0e201b8d794c8282c40cf2e.png"
                            style={{ marginRight: 5, height: 14 }}
                            alt="备案图标"
                        />
                        <a
                            href="https://beian.mps.gov.cn/#/query/webSearch?code=2021000956"
                            target="_blank"
                            rel="nofollow noreferrer"
                            style={{ alignItems: "center" }}
                        >
                            沪ICP备2021000956号
                        </a>
                    </div>

                </div>
                <div style={{ display: 'flex', alignItems: 'center', fontSize: '16px', color: '#ffffff' }}>
                    <div style={{ padding: '0px 12px' }}>
                        <a style={{ fontSize: '16px', color: '#ffffff', textDecoration: 'none' }} href={xiaohongshu_link} target="_blank">小红书</a>
                    </div>
                    <div style={{ padding: '0px 12px' }}>
                        <a style={{ fontSize: '16px', color: '#ffffff', textDecoration: 'none' }} href={bilibili_link} target="_blank">bilibili</a>
                    </div>
                    <div style={{ padding: '0px 12px' }}>
                        <a style={{ fontSize: '16px', color: '#ffffff', textDecoration: 'none' }} href={douyin_link} target="_blank">抖音</a>
                    </div>
                    <div style={{ padding: '0px 12px', cursor: 'pointer', marginRight: '12px' }}>
                        <Popover
                            getPopupContainer={(trigger: any) => trigger.parentElement}
                            content={<img style={{ width: 'auto', height: '300px' }} src={VIDEO_IMG} alt="video" />}
                            placement="topLeft"
                            color="#191824"
                            arrow={false}
                        // open={true}
                        >
                            <span>视频号</span>
                        </Popover>
                    </div>
                </div>
            </div>
        </>

    )
}
